export default function textToLines(text: string, maxLines?: number): string[] {
  if (maxLines === 1) {
    return [text]
  }

  const lines: string[] = []

  let index = 0
  let lastIndex = 0
  do {
    index = text.indexOf('\n', lastIndex)
    if (index !== -1) {
      // index === lastIndex for empty lines
      if (index !== lastIndex) {
        const sliced = text.slice(lastIndex, index).trim()
        if (sliced.length > 0) {
          // ^ Ignore empty lines
          lines.push(sliced)
        }
      }
      index += 1
    }
    if (index !== -1) {
      lastIndex = index
    }
  } while (index !== -1 && (maxLines == null || lines.length < maxLines - 1))

  if (index !== text.length) {
    const sliced = text.slice(lastIndex).trim()
    if (sliced.length > 0) {
      // ^ Ignore empty lines
      lines.push(sliced)
    }
  }

  return lines
}
